<script setup>

// import Swiper core and required modules
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Swiper modules
const modules = [Navigation, Pagination, A11y];

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/zoom';

var swiperInstance;

const onSwiper = (swiper) => {
	swiperInstance = swiper;
};

const slideTo = (index) => {
	swiperInstance.slideTo(index);
}

</script>

<template>

	<swiper class="products-slider" :modules="modules" :slides-per-view="itemsToShow" :space-between="0"
		:pagination="{ clickable: true }" @swiper="onSwiper">

		<swiper-slide v-for="(item, itemKey) in items">
			<ProductTile :data="item" :key="itemKey"></ProductTile>
		</swiper-slide>

	</swiper>

</template>

<script>

export default {
	name: "ProductsSlider",
	components: {},
	props: ['items'],
	data() {
		return {
			itemsToShow: 1,
		}
	},
	mounted() {
		var vm = this;
		vm.calculateItemsToShow();
		window.removeEventListener('resize', () => { }, false)
		window.addEventListener('resize', vm.calculateItemsToShow);
	},
	methods: {

		calculateItemsToShow() {

			var vm = this;
			let windowWidth = window.innerWidth;

			let thresholds = [
				{
					min: 0,
					max: 767,
					itemsToShow: 2
				},
				{
					min: 768,
					max: 991,
					itemsToShow: 3
				},
				{
					min: 992,
					max: 1199,
					itemsToShow: 3
				},
				{
					min: 1200,
					max: 1399,
					itemsToShow: 4
				},
				{
					min: 1400,
					max: 10000,
					itemsToShow: 5
				},
			];

			thresholds.map(threshold => {
				if (windowWidth >= threshold.min && windowWidth <= threshold.max)
					vm.itemsToShow = threshold.itemsToShow > vm.items.length ? vm.items.length : threshold.itemsToShow;
			});

		}

	}
}
</script>